module.exports = __webpack_public_path__ + "static/media/lk-puzzle-cargills-main_store.270a2747.png";